document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const searchInput = document.querySelector('.header__search input');
  const searchWidget = document.querySelector('.boost-sd__search-widget-init-wrapper');

  const closeBtn = document.getElementById('search-close-btn');
  const details = document.querySelector('.header__search details');
  const searchSummary = document.querySelector('.header__search summary.header__icon--search');
  const resetBtn = document.querySelector('.header__search .reset__button');

  if (!header) return;

  /* ===============================
     CENTRAL STATE CONTROLLER
  =============================== */

  const updateHeaderState = () => {
    const anyMegaOpen = document.querySelector('.mega-menu[open]');
    const boostOpen = document.body.classList.contains('boost-sd__search-opening');

    const isActive = anyMegaOpen || boostOpen;

    header.classList.toggle('header-active', isActive);

    const isSearchTemplate = document.body.classList.contains('template-search');

    document.body.classList.toggle(
      'body-header-active',
      isActive && !isSearchTemplate
    );

    if (searchWidget) {
      searchWidget.style.display = anyMegaOpen ? 'none' : '';
    }
  };

  /* ===============================
     SEARCH INPUT MONITOR
  =============================== */

  if (searchInput) {
    searchInput.addEventListener('input', updateHeaderState);
  }

  /* ===============================
     MEGA MENU (DESKTOP ONLY)
  =============================== */

  document.querySelectorAll('.mega-menu').forEach((detailsEl) => {
    const summary = detailsEl.querySelector('summary');

    const updateAria = () => {
      summary?.setAttribute('aria-expanded', detailsEl.hasAttribute('open'));
    };

    detailsEl.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(min-width: 991px)').matches) return;

      detailsEl.setAttribute('open', '');
      updateAria();
      updateHeaderState();
    });

    detailsEl.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(min-width: 991px)').matches) return;

      detailsEl.removeAttribute('open');
      updateAria();
      updateHeaderState();
    });
  });

  /* ===============================
     SEARCH CLOSE LOGIC
  =============================== */

  if (closeBtn && details && searchSummary) {

    searchSummary.addEventListener('click', () => {
      requestAnimationFrame(() => {
        closeBtn.style.display = details.hasAttribute('open')
          ? 'inline-flex'
          : 'none';
      });
    });

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      resetBtn?.click();
      closeSearchCompletely();
    });
  }

  function closeSearchCompletely() {
    // Close <details>
    details?.removeAttribute('open');

    // Hide close button
    if (closeBtn) closeBtn.style.display = 'none';

    // Remove Boost class aggressively
    forceRemoveBoostClass();

    // Clear input value
    if (searchInput) searchInput.value = '';

    // Update header state immediately
    updateHeaderState();
  }

  function forceRemoveBoostClass() {
    const cls = 'boost-sd__search-opening';

    document.body.classList.remove(cls);

    setTimeout(() => {
      document.body.classList.remove(cls);
      updateHeaderState(); // sync again after async
    }, 200);
  }

  /* ===============================
     OBSERVE BODY CLASS CHANGES
     (for Boost async behavior)
  =============================== */

  const observer = new MutationObserver(updateHeaderState);

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

});
